import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollManager() {
  const { pathname, hash } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    const samePage = prevPathnameRef.current === pathname;
    prevPathnameRef.current = pathname;

    if (hash) {
      const id = hash.replace("#", "");
      let attempts = 0;
      const maxAttempts = 60;

      const scrollToSection = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({
            behavior: samePage ? "smooth" : "auto",
            block: "start",
          });
        } else if (attempts < maxAttempts) {
          attempts += 1;
          requestAnimationFrame(scrollToSection);
        } else {
          window.scrollTo(0, 0);
        }
      };

      // Wait one frame so the newly-routed page has a chance to render.
      requestAnimationFrame(scrollToSection);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}